<!-- <div class="home-container">
    <div class="row">
        <div class="col-md-6">
            <div class="card" [class.active]="activeMetric === 'events'" [routerLink]="'/events'">
                <h2>Eventos</h2>
                <p>Number of events</p>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card" [class.active]="activeMetric === 'followers'">
                <h2>Calendario</h2>
                <p>Próximo evento en 7 días</p>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card" [class.active]="activeMetric === 'followers'">
                <h2>Reservas</h2>
                <p>Number of followers</p>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card" [class.active]="activeMetric === 'followers'">
                <h2>Interacciones</h2>
                <p>Number of followers</p>
            </div>
        </div>
    </div>
</div> -->

<app-home></app-home>